import { render } from "./EpiLink.vue?vue&type=template&id=d68a18d6"
import script from "./EpiLink.vue?vue&type=script&lang=js"
export * from "./EpiLink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__